import { track } from '@leagueplatform/analytics';
import { Button, Responsive, StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { CHALLENGE_CAMPAIGN_TYPE } from '#constants/analytics.constants.tsx';
import { useParamsLegacy as useParams } from '@leagueplatform/routing';
import { useGetChallengeByIdData } from '#pages/challenge-landing-page/hooks/use-get-challenge-by-id-data.hook.ts';
import { BUTTON_CONTAINER_MAX_WIDTH } from '#constants/challenges.constants.tsx';
import React from 'react';

interface SignUpButtonProps {
  setDisplaySignUpModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SignUpButton = ({ setDisplaySignUpModal }: SignUpButtonProps) => {
  const { formatMessage } = useIntl();
  const { challengeId } = useParams<{ challengeId: string }>();
  const { data: challengeData } = useGetChallengeByIdData();
  return (
    <Button
      onClick={() => {
        setDisplaySignUpModal(true);
        track('challenges.button_clicked.health_campaign_detail.sign_up', {
          health_campaign_id: challengeId ?? '',
          health_campaign_name: challengeData?.data.title ?? '',
          health_campaign_type: CHALLENGE_CAMPAIGN_TYPE,
          challenge_status: challengeData?.data.status ?? '',
        });
      }}
      width="fillContainer"
      css={{
        maxWidth: BUTTON_CONTAINER_MAX_WIDTH,
      }}
    >
      {formatMessage({ id: 'SIGN_UP_FOR_CHALLENGE' })}
    </Button>
  );
};

export const MobileResponsiveSignUpButton = ({
  setDisplaySignUpModal,
}: SignUpButtonProps) => (
  <Responsive down="laptop">
    <StackLayout
      css={{
        position: 'fixed',
        bottom: 0,
        insetInlineStart: 0,
        width: '100%',
        backgroundColor: '$surfaceBackgroundPrimary',
        height: '$five',
        padding: '$one',
        zIndex: '1',
      }}
      horizontalAlignment="center"
      verticalAlignment="center"
    >
      <SignUpButton setDisplaySignUpModal={setDisplaySignUpModal} />
    </StackLayout>
  </Responsive>
);
